import { points as en_points } from "../en/points";

/** points — RU slice. */
export const points: Record<keyof typeof en_points, string> = {
  points_launcher_tab_open_button: "Баллы и награды",

  // My Points (home)
  points_home_balance_label: "Баллы",
  points_home_stat_this_week: "За неделю",
  points_home_stat_this_month: "За месяц",
  points_home_stat_all_time: "За всё время",
  points_home_stat_redeemed: "Потрачено",
  points_home_recent_activity_title: "Последние действия",
  points_home_recent_activity_empty: "Пока нет действий",
  points_home_see_all_button: "Показать всё →",

  // Navigation rows
  points_nav_rewards: "Магазин наград",
  points_nav_achievements: "Достижения",
  points_nav_history: "История баллов",
  points_nav_invite: "Приглашай и зарабатывай",

  // Relative time
  points_time_just_now: "только что",
  points_time_minutes_ago: "{count} мин назад",
  points_time_hours_ago: "{count} ч назад",
  points_time_days_ago: "{count} дн назад",

  // Ledger source labels
  points_source_profile_completion: "Профиль заполнен",
  points_source_daily_login: "Ежедневный вход",
  points_source_referral: "Бонус за приглашение",
  points_source_card_exchange: "Обмен карточками",
  points_source_experience_confirmation: "Встреча подтверждена",
  points_source_achievement: "Достижение открыто",
  points_source_founding_member: "Участник-основатель",
  points_source_event_check_in: "Отметка на событии",
  points_source_tap_connect: "Подключение касанием",
  points_source_qr_swap: "Обмен по QR",
  points_source_social_share: "Публикация в соцсетях",
  points_source_invite_new_user: "Друг присоединился",
  points_source_mini_game: "Мини-игра",
  points_source_photo_challenge: "Фотозадание",
  points_source_leaderboard: "Таблица лидеров",
  points_source_reward_redemption: "Награда получена",
  points_source_admin_adjustment: "Корректировка",

  // Rewards Store
  points_rewards_category_badges: "Значки",
  points_rewards_category_perks: "Привилегии",
  points_rewards_category_merch: "Мерч",
  points_rewards_category_events: "События",
  points_rewards_category_partner: "Партнёрские привилегии",
  points_rewards_coming_soon_tag: "Скоро",
  points_rewards_filter_all: "Все",
  points_rewards_empty: "В этой категории пока нет наград",
  points_rewards_state_coming_soon: "🔒 Скоро",
  points_rewards_state_owned: "✅ Получено",
  points_rewards_redeem_button: "Получить",
  points_rewards_need_more: "Не хватает {count}",
  points_rewards_redeem_dialog_title: "Получить «{name}»?",
  points_rewards_redeem_dialog_description:
    "С твоего счёта спишется {cost} Баллов, и награда будет добавлена. Значки выдаются навсегда.",
  points_rewards_redeem_cancel: "Отмена",
  points_rewards_redeeming: "Получаем…",
  points_rewards_redeem_confirm: "Подтвердить · {cost}",

  // Rewards Store — badges help
  points_rewards_badges_help_aria: "Как получить бейджи",
  points_rewards_badges_help_title: "Как получить бейджи",
  points_rewards_badges_help_intro:
    "Бейджи постоянные и отображаются на вашей Linq Card. Их можно получить за баллы. Баллы начисляются за ежедневный вход, заполнение профиля, новые связи, посещение событий и приглашение друзей.",
  points_rewards_badges_help_how: "Получить за {cost} баллов",
  points_rewards_badges_help_coming_soon: "Скоро",
  points_rewards_badges_help_granted:
    "Некоторые бейджи, например Founding Member, выдаются автоматически и не покупаются.",
  points_rewards_badges_help_close: "Понятно",

  // Achievements
  points_achievements_unlocked_count: "{unlocked} / {total} открыто",
  points_achievements_milestones_title: "Этапы",
  points_achievements_badges_title: "Твои значки",
  points_achievements_badges_get: "Получить",
  points_achievements_badges_empty:
    "Пока нет значков — получи один в Магазине наград.",
  points_achievements_first_connection: "Заведи первое знакомство",
  points_achievements_reach_connections: "Набери {count} знакомств",
  points_achievements_attend_events: "Посети {count} событий",
  points_achievements_unlocks_with_events: "Откроется с Событиями",

  // Points History
  points_history_filter_all: "Все",
  points_history_filter_earned: "Начислено",
  points_history_filter_spent: "Потрачено",
  points_history_day_today: "Сегодня",
  points_history_day_yesterday: "Вчера",
  points_history_empty: "Здесь пока пусто.",
  points_history_redeemed_badge: "Потрачено",
  points_history_loading_more: "Загрузка…",
  points_history_load_more: "Загрузить ещё",

  // Invite & Earn
  points_invite_hero_title: "Приглашай друзей и зарабатывай Баллы",
  points_invite_hero_description:
    "Получай +{count} Баллов каждый раз, когда друг присоединяется по твоей ссылке и завершает настройку.",
  points_invite_link_label: "Твоя ссылка для приглашения",
  points_invite_copied: "Скопировано!",
  points_invite_copy: "Копировать",
  points_invite_share_button: "Поделиться ссылкой",
  points_invite_share_title: "Присоединяйся ко мне в Linqx",
  points_invite_how_it_works_title: "Как это работает",
  points_invite_step_share: "Поделись своей ссылкой",
  points_invite_step_friend_opens: "Друг открывает её и регистрируется",
  points_invite_step_onboarding: "Он завершает настройку",
  points_invite_step_reward: "Ты получаешь +{count} Баллов",
  points_invite_footer_note: "Начисления появятся в Истории баллов",
};
